import { validationsFn } from './validations';

const loginValidations = (t) => {
  return {
    validationsFn: validationsFn(t),
  };
};

export default loginValidations;
